<template>
  <div class="alpha-bank-error">
    {{ error }}
  </div>
</template>

<script setup lang="ts">
interface Props {
  error: string
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.alpha-bank-error {
  @apply text-center text-red-500 py-8;
}
</style>
